import React, { createContext, useContext, useEffect, useState } from "react";
import { LANGUAGES } from "../i18n";

const LanguageContext = createContext(undefined);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return LANGUAGES.TR;
    // Check if user has explicitly made a language choice previously
    const explicitChoice = window.localStorage.getItem("profinoks_lang_selected");
    if (explicitChoice === LANGUAGES.EN || explicitChoice === LANGUAGES.TR) {
      return explicitChoice;
    }
    // Default is always Turkish (TR) for all devices and platforms
    return LANGUAGES.TR;
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("profinoks_lang", lang);
    }
  }, [lang]);

  const toggleLang = () => {
    setLang((prev) => {
      const nextLang = prev === LANGUAGES.EN ? LANGUAGES.TR : LANGUAGES.EN;
      if (typeof window !== "undefined") {
        window.localStorage.setItem("profinoks_lang_selected", nextLang);
      }
      return nextLang;
    });
  };

  const changeLang = (newLang) => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("profinoks_lang_selected", newLang);
    }
    setLang(newLang);
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, toggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
